import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Box, Drawer } from '@mui/material';

import { Home, AttachMoney, Style, Close, School } from '@mui/icons-material';

import UsefulLinks from './UsefulLinks';
import { getProperty } from '../../helpers/properties';;
import CourseSelect from './CourseSelect';
import { getHamburgerMenuLink } from '../../services/reservoir';
import HamburgerMenuAccordion from './HamburgerMenuAccordion';
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse } }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    locationCode: selectedCourse.locationCd
  };
};

class HamburgerMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerMenuLinks: {
        data: [],
        included: []
      }
    };
  }

  componentDidMount() {
    this.loadHamburgerMenuLink();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.admissionCategory !== this.props.admissionCategory) {
      this.loadHamburgerMenuLink();
    }
  }

  loadHamburgerMenuLink = () => {
    getHamburgerMenuLink(
      this.props.admissionCategory,
      this.props.locationCode
    ).then(hamburgerMenuLinks => {
      this.setState({
        hamburgerMenuLinks: hamburgerMenuLinks
      });
    });
  };

  getLinkIcon = linkIcon => {
    switch (linkIcon) {
      case 'Resource':
        return <Style className="btn-point-events" />;
      case 'Hat':
        return <School className="btn-point-events" />;
      case 'Dollar':
        return <AttachMoney className="btn-point-events" />;
      case 'Home':
      default:
        return <Home className="btn-point-events" />;
    }
  };

  buildLink = (id, url, title) => {
    return {
      id: id,
      url: url,
      title: title
    };
  };

  buildLinks = (nestedLinks = []) => {
    return nestedLinks.reduce((accumulator, { id }) => {
      const nestedLink = this.state.hamburgerMenuLinks.included.find(
        hamburgerMenuLink => hamburgerMenuLink.id === id
      );

      if (nestedLink && nestedLink.attributes) {
        return accumulator.concat(
          this.buildLink(
            id,
            getConfiguration('baseUrl') + '/' + nestedLink.attributes.field_slug,
            nestedLink.attributes.title
          )
        );
      }

      return accumulator;
    }, []);
  };

  handleHamburgerMenuLinkClick = (id, title, url) => {
    window.dataLayer.push({
      event: 'custom.menu.click',
      label: title,
      group: 'Hamburger Menu Link Tabs',
      info: {
        url: url,
        id: id,
        location: 'Hamburger Menu'
      }
    });

    this.props.onClose();
  };

  handleClickHamburgerMenuClose = () => {
    window.dataLayer.push({
      event: 'custom.menu.close',
      label: 'Close',
      group: 'Hamburger Menu',
      location: 'Hamburger Menu'
    });

    this.props.onClose();
  };

  handleToggleHamburgerMenuClose = drawerOpen => {
    window.dataLayer.push({
      event: 'custom.menu.close',
      label: 'Close',
      group: 'Hamburger Menu',
      location: 'Hamburger Menu'
    });

    this.props.onRequestChange(drawerOpen);
  };

  render() {
    return (
      <Drawer
        PaperProps={{ style: { width: 320, height: '100%', overflowY: 'auto' } }}
        onClose={this.handleClickHamburgerMenuClose}
        open={this.props.open}
      >
        <Box
          role="presentation"
          sx={{ height: '100%'}}
        >
          <div className="slidein__content">
            <div className="slidein__close">
              <button
                className="slidein__btn-close"
                onClick={this.handleClickHamburgerMenuClose}
              >
                <span className="sr-only">Close Sidebar</span>
                <Close className="btn-point-events" />
              </button>
            </div>

            <CourseSelect />

            {this.state.hamburgerMenuLinks.data.map(
              ({ id, attributes, relationships }) => {
                if (attributes.field_has_nested_links) {
                  if (
                    relationships.field_nested_links &&
                    relationships.field_nested_links.data
                  ) {
                    return (
                      <HamburgerMenuAccordion
                        key={id}
                        title={
                          <h2 className="slidein__section-heading btn-point-events">
                            {this.getLinkIcon(attributes.field_icon_)}{' '}
                            {attributes.field_heading_myvu_}
                          </h2>
                        }
                        links={this.buildLinks(
                          relationships.field_nested_links.data
                        )}
                        onLinkSelect={this.handleHamburgerMenuLinkClick}
                      />
                    );
                  }

                  return null;
                }

                return (
                  <Link
                    key={id}
                    className={[
                      'slidein__section',
                      attributes.field_heading_myvu_.split(' ').join('-')
                    ].join(' ')}
                    to={getConfiguration('baseUrl') + attributes.field_internal_link}
                    onClick={() =>
                      this.handleHamburgerMenuLinkClick(
                        id,
                        attributes.field_heading_myvu_,
                        getConfiguration('baseUrl') + attributes.field_internal_link
                      )
                    }
                  >
                    <h2 className="slidein__section-heading btn-point-events">
                      {this.getLinkIcon(attributes.field_icon_)}{' '}
                      {attributes.field_heading_myvu_}
                    </h2>
                  </Link>
                );
              }
            )}

            {/*<Link className={'slidein__section'} to={getConfiguration('baseUrl') + '/afs'}>*/}
            {/*<h2 className='slidein__section-heading btn-point-events'>AFS</h2>*/}
            {/*</Link>*/}

            <UsefulLinks />
          </div>
        </Box>
      </Drawer>
    );
  }
}

export default withRouter(connect(mapStateToProps)(HamburgerMenu));
